import {cva} from 'class-variance-authority';

export const buttonVariants = cva(
  "text-base inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-all cursor-pointer disabled:cursor-forbiden disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none",
  {
    variants: {
      variant: {
        primary: "bg-general-green-800 text-general-gray-100 hover:bg-general-green-900",
        secondary:
          "bg-general-gray-100 text-general-green-800 hover:bg-general-mint-600 border-general-green-800 border",
        destructive: "bg-general-red-800 text-white hover:bg-general-red-900",
        destructiveOutline:
          "bg-general-gray-100 hover:bg-general-red-700 text-general-red-800 border border-general-red-800",
        ghost: "",
        dotted: "bg-general-mint-600 text-general-green-800 border border-dashed border-general-gray-700",
      },
      size: {
        default: "h-14", // Set fixed height
        small: "h-10 text-sm",
        icon: "h-10 w-10 p-0",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);